import { Injectable, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "../services/local-storage.service";
import { EmisorService } from "../services/emisor.service";
import { TokenStorageService } from "../services/token-storage.service";
import { NotificationService } from "../services/notification.service";
import Swal, { SweetAlertResult } from "sweetalert2";
import { Emisor } from "../models/Emisor/Emisor";
import { ReplaySubject, Subject } from "rxjs";
import { RoleGuard } from "../modules/auth/_services/role.guard";
import { VerificacionCertificadoService } from "./verificacion-certificado.service";
import { PlanUsuario } from "../models/PlanesUsuario/PlanUsuario";
import { PlanUsuarioService } from "./planUsuario.service";
import { DatePipe } from "@angular/common";
import { ModalsRegularizacionComponent } from "../components/layout/modals-regularizacion/modals-regularizacion.component";
import { AuthService } from "../modules/auth";
import { UsuarioService } from "./usuario.service";
import { DatosFacturacionService } from "./datos-facturacion-service";
import { ModalCommunicationService } from "./payment-modals-communication-service.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SessionUser } from "../shared/models/sessionUser";

@Injectable({
	providedIn: "root",
})
export class ChangeCompanyService {
	companyChanged = new Subject<Emisor>();
	private planChangedSubject = new ReplaySubject<PlanUsuario>(1);
	planChanged$ = this.planChangedSubject.asObservable();

	private modalPagoPlanTemplate!: TemplateRef<any>;
	private modalChangeCompanyTemplate!: TemplateRef<any>;
	public user: SessionUser;
	private modalRefPago!: NgbModalRef;
	private modalRefChangeCompany!: NgbModalRef;
	public hasReseller: boolean;
	private inactiveCompanyAlertId: string | null = null;

	constructor(
		private router: Router,
		private validadorCertificadoService: VerificacionCertificadoService,
		private localStorage: LocalStorageService,
		private tokenService: TokenStorageService,
		private emisorService: EmisorService,
		private notifications: NotificationService,
		private planUsuarioService: PlanUsuarioService,
		private authService: AuthService,
		public datosFacturacionServicce: DatosFacturacionService,
		private modalCommunicationService: ModalCommunicationService,
		private datePipe: DatePipe,
		public modalService: NgbModal
	) {}

	notifyPlanChanged(plan: PlanUsuario): void {
		this.planChangedSubject.next(plan);
	  }

	SetNewCompany(currentEmisorObject: Emisor, currentSucursalId: string, redirectUrl?: string): void {
		if (!currentEmisorObject.activo) {
            this.handleSeleccionEmpresaInactiva(currentEmisorObject);
            return;
        }
		this.closeAllModals();
		this.applyCompanyContext(currentEmisorObject, currentSucursalId, redirectUrl);
		void Swal.fire({
			title: "Cambio de Empresa",
			icon: "info",
			html: "<h5>Ahora opera en " + currentEmisorObject.razonSocial + "</h5>",
			showCloseButton: false,
			showCancelButton: false,
			focusConfirm: true,
			confirmButtonText: '<i class="fa fa-thumbs-up"></i> Entendido',
			customClass: {
				confirmButton: "btn btn-success",
			},
		});
		this.notifications.hubStopConnections();
	}

	private applyCompanyContext(
		currentEmisorObject: Emisor,
		currentSucursalId: string,
		redirectUrl?: string,
	): void {
		RoleGuard.reload$.next();
		const currentUrl = this.router.url;
		const waitNavigation = this.router.navigateByUrl("/wait-route", { skipLocationChange: true });
		this.user = this.tokenService.getUser() as SessionUser;
		const emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];

		this.planUsuarioService.getPlanesByCompany(currentEmisorObject.emisorId).subscribe((planes) => {
			this.user.planes = planes;
			const plan = this.verifyAlertPayment(this.user.planes, emisoresSource.length);
			this.notifyPlanChanged(plan);
			const destination = plan != null && plan.activo && plan.diasDiferencia > -29
				? redirectUrl || currentUrl
				: "/inicio";
			void waitNavigation.then(() => this.router.navigateByUrl(destination));
		});

		this.emisorService
			.setActualBranchOffice(currentSucursalId, this.user.id)
			.subscribe();
		this.emisorService.getAdicionales(currentEmisorObject.emisorId).subscribe({
			next: (res) => {
				this.localStorage.saveAdicionales(res);
				this.companyChanged.next(currentEmisorObject);
			},
			error: (error) => {
				console.error("Error al obtener adicionales", error);
				this.localStorage.saveAdicionales([]);
				this.companyChanged.next(currentEmisorObject);
			},
		});
	}

	setModalPagoPlanTemplate(template: TemplateRef<any>) {
		this.modalPagoPlanTemplate = template;
	}

	setModalChangeCompanyTemplate(template: TemplateRef<any>) {
		this.modalChangeCompanyTemplate = template;
	}
	showModalSelectorEmpresa(showCloseButton: boolean) {

		this.modalCommunicationService.emitirCargarDatos();
		this.cerrarModalPago();
		this.modalRefChangeCompany = this.modalService.open(this.modalChangeCompanyTemplate, {
			keyboard: showCloseButton,
			backdrop: showCloseButton ? true : "static",
		});
	}

	showModalPagoPlan() {
		if (!this.modalPagoPlanTemplate) {
			throw new Error("Modal template for payment plan is not set.");
		}
		this.cerrarModalCambiarEmpresa();
		this.modalCommunicationService.emitirCargarDatos();
		this.modalRefPago = this.modalService.open(this.modalPagoPlanTemplate, {
			windowClass: "",
			size: "xl",
			backdrop: "static",
			keyboard: false,
		});
	}
	

	cerrarModalPago() {
		if (this.modalRefPago) {
			try {
				this.modalRefPago.close();
			} catch (e) {
				// Modal ya fue cerrado
			}
			this.modalRefPago = null;
		}
	}

	cerrarModalCambiarEmpresa() {
		if (this.modalRefChangeCompany) {
			try {
				this.modalRefChangeCompany.close();
			} catch (e) {
				// Modal ya fue cerrado
			}
			this.modalRefChangeCompany = null;
		}
	}

	private closeAllModals(): void {
		this.cerrarModalPago();
		this.cerrarModalCambiarEmpresa();
	}

	verifyAlertPayment(planes: Array<PlanUsuario>, emisoresCount: number): PlanUsuario {
		let planActual: PlanUsuario;
		for (let i = planes.length - 1; i >= 0; i--) {
			if (planes[i].emisorId === this.tokenService.getCompany()) {
				planActual = planes[i];
				break;
			}
		}
		this.user = this.tokenService.getUser() as SessionUser;
		this.hasReseller = this.tokenService.userHasReseller();
		if (planActual == undefined) {
			if (planes.every((x) => x.emisorId == null)) {
				const mensaje = "No tienes un plan vigente. Contacta con Area Comercial";
				Swal.fire({
					icon: "error",
					title: "Acceso bloqueado",
					allowOutsideClick: false,
					allowEscapeKey: false,
					text: mensaje,
					confirmButtonText: "Salir",
				}).then((result) => {
					this.authService.logout().subscribe();
				});
			} else planActual = planes[0];
		} else if (planActual.diasDiferencia < -15 || (planActual.formaPago == "free" && planActual.pagado == false && planActual.diasDiferencia < 0)) {
			if (this.hasReseller) return planActual;
			
			const mostrarBotonRegularizar = !(this.hasReseller && this.user.id == planActual.usuarioId);
			const esReactivacion = planActual.diasDiferencia < -15;
			const mensaje = esReactivacion
				? "Tu plan ya no está vigente. Puedes renovarlo para volver a usar SimpleFactura. El vencimiento y los montos se indicarán al cotizar."
				: "Tu plan venció el " + this.datePipe.transform(planActual.fechaCaducidad, "dd/MM/yyyy") + ". Para continuar usando SimpleFactura favor regulariza tu situación";
			this.closeAllModals();
			Swal.fire({
				icon: "error",
				title: "Acceso bloqueado",
				allowOutsideClick: false,
				allowEscapeKey: false,
				text: mensaje,
				showCancelButton: emisoresCount > 1,
				cancelButtonText: "Cambiar de empresa",
				showConfirmButton: mostrarBotonRegularizar,
				confirmButtonText: esReactivacion ? "Renovar plan" : "Regularizar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.showModalPagoPlan();
				} else if (result.isDenied || result.dismiss){
					this.showModalSelectorEmpresa(false);
				}
			});
		} else if (planActual.diasDiferencia < 0 && planActual.isDemo) {
			const fechaActual = new Date();
			this.closeAllModals();
			Swal.fire({
				icon: "error",
				title: "Acceso bloqueado",
				allowOutsideClick: false,
				allowEscapeKey: false,
				text: "Ya ha terminado tu período de evaluación gratuita. Para continuar usando SimpleFactura debes adquirir un plan",
				confirmButtonText: "Regularizar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.showModalPagoPlan();
				} else if (result.isDismissed) {
					this.authService.logout().subscribe();
				}
			});
		} else if (planActual.diasDiferencia < 0) {
			if (this.hasReseller) return planActual;
			const fechaActual = new Date();
			const fechaVencimiento = new Date();
			fechaVencimiento.setDate(fechaActual.getDate() + planActual.diasDiferencia + 15);
			this.closeAllModals();
			Swal.fire({
				icon: "error",
				title: "Necesitamos tu atención",
				allowOutsideClick: false,
				allowEscapeKey: false,
				text: "Tienes un plan en mora. Favor regularizar para evitar bloqueo. Fecha estimada de suspensión: " + this.datePipe.transform(fechaVencimiento, "dd/MM/yyyy"),
			});
		}
		return planActual;
	}
	evaluarAccesoAlLogin(): boolean {
		this.user = this.tokenService.getUser() as SessionUser;

		if (!this.user) return false;

		const emisores = JSON.parse(this.localStorage.getEmisores() || "[]") as Emisor[];
		const emisoresInactivos = emisores.filter((e) => !e.activo);
		const emisorActualId = this.tokenService.getCompany();
		const emisorActual = emisores.find((e) => e.emisorId === emisorActualId);
		const requiereRegularizacion =
			this.user.requiereRegularizacionAutomatica === true ||
			emisorActual?.activo === false ||
			(emisores.length === 1 && emisoresInactivos.length === 1);

		if (requiereRegularizacion) {
			if (this.inactiveCompanyAlertId === emisorActualId) return true;
			this.inactiveCompanyAlertId = emisorActualId;
			this.closeAllModals();
			if (emisorActual?.suspendidoPorMora) {
				this.showPartnerBlockedAlertAndLogout();
			} else if (this.tokenService.userHasReseller() || this.tienePlanVigente(emisorActualId)) {
				this.showInactiveCompanyAlert(emisores.some(e => e.activo));
			} else {
				this.router.navigateByUrl("/pago/regularizacion");
			}
			return true;
		}
		this.inactiveCompanyAlertId = null;
		return false;
	}
	 handleSeleccionEmpresaInactiva(emisor: Emisor): void {
		const esPartner = this.tokenService.userHasReseller() || (emisor.resellerId != null && emisor.resellerId !== "");
		if (emisor.suspendidoPorMora) {
			this.showPartnerBlockedAlertAndLogout();
			return;
		}
		if (esPartner || this.tienePlanVigente(emisor.emisorId)) {
			void Swal.fire({
				icon: "info",
				title: "Empresa desactivada",
				text: "Esta empresa está desactivada. Para volver a utilizarla, solicita su activación a un administrador.",
				confirmButtonText: "Entendido",
			});
			return;
		}
        Swal.fire({
            icon: "warning",
            title: "Plan sin vigencia",
            html: `
                <p>El plan de la empresa <strong>${emisor.razonSocial}</strong> ya no se encuentra vigente.</p>
                <p>Puedes renovarlo para volver a operar desde la fecha del nuevo pago.</p>
            `,
            showCancelButton: true,
            confirmButtonText: '<i class="fas fa-credit-card"></i> Renovar / Contratar plan',
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#6c757d",
            allowOutsideClick: false,
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-secondary",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                this.closeAllModals();
				this.router.navigateByUrl("/pago/regularizacion");
            }
        });
    }

	private tienePlanVigente(emisorId: string): boolean {
		const user = this.tokenService.getUser() as SessionUser;
		return (user?.planes || []).some(p => p.emisorId === emisorId && p.activo && p.diasDiferencia >= 0);
	}

	private showInactiveCompanyAlert(hayEmpresasActivas: boolean): void {
		void Swal.fire({
			icon: "info",
			title: "Empresa desactivada",
			text: hayEmpresasActivas
				? "Esta empresa está desactivada. Puedes continuar con otra empresa activa."
				: "Esta empresa está desactivada. Para volver a utilizarla, solicita su activación a un administrador.",
			allowOutsideClick: false,
			allowEscapeKey: false,
			confirmButtonText: hayEmpresasActivas ? "Cambiar de empresa" : "Salir",
		}).then(() => {
			if (hayEmpresasActivas) this.showModalSelectorEmpresa(false);
			else this.authService.logout().subscribe();
		});
	}

	private showPartnerBlockedAlertAndLogout(): void {
		this.closeAllModals();
		Swal.fire({
			icon: "error",
			title: "Acceso bloqueado",
			allowOutsideClick: false,
			allowEscapeKey: false,
			text: "Cuenta bloqueada por no pago; comunícate con el área comercial al correo comercial@chilesystems.com",
			confirmButtonText: "Salir",
		}).then(() => {
			this.authService.logout().subscribe();
		});
	}
}
